import { QuizQuestion } from "../../../common/components/quiz/useQuiz";

export const notificationsQuizQuestions: QuizQuestion[] = [
  {
    id: "notifications-q1",
    prompt: "What types of notifications will you find on this page?",
    options: [
      { id: "a", label: "Only login alerts" },
      {
        id: "b",
        label: "Security alerts, access changes, and system updates affecting your account",
      },
      { id: "c", label: "Billing and payment reminders only" },
      { id: "d", label: "Messages from other users" },
    ],
    correctOptionId: "b",
    explanation:
      "The Notifications page shows security alerts, access changes (like being removed from a facility), new sign-in alerts, and other system updates.",
  },
  {
    id: "notifications-q2",
    prompt: "What does the 'Unread' tab show?",
    options: [
      { id: "a", label: "All archived notifications" },
      { id: "b", label: "Notifications from the past 7 days" },
      { id: "c", label: "Only notifications you haven't opened yet" },
      { id: "d", label: "Notifications marked as important" },
    ],
    correctOptionId: "c",
    explanation:
      "The Unread tab filters the list to show only notifications you haven't read yet, making it easy to catch up on what's new.",
  },
  {
    id: "notifications-q3",
    prompt: "What does 'Mark All as Read' do?",
    options: [
      { id: "a", label: "Deletes all notifications" },
      { id: "b", label: "Archives all visible notifications" },
      {
        id: "c",
        label: "Marks all currently visible notifications as read at once",
      },
      { id: "d", label: "Sends a report to your email" },
    ],
    correctOptionId: "c",
    explanation:
      "The Mark All as Read button updates the read status of all visible notifications in the current tab at once, clearing your unread count.",
  },
  {
    id: "notifications-q4",
    prompt: "How are notifications grouped in the list?",
    options: [
      { id: "a", label: "By notification type" },
      { id: "b", label: "By date — Today, Yesterday, Last Week, and Older" },
      { id: "c", label: "Alphabetically by title" },
      { id: "d", label: "By read status only" },
    ],
    correctOptionId: "b",
    explanation:
      "Notifications are grouped by date under collapsible sections: Today, Yesterday, Last Week, Last Month, and Older, for easy browsing.",
  },
];
